interface messageType {
  name: string;
  lastMessage: string;
  lastMessageDate: string;
}

export const messageData: messageType[] = [
  {
    name: 'Binod Chaulagain',
    lastMessage: 'Hello',
    lastMessageDate: '16 hours ago',
  },

  {
    name: 'Nitish Rajak',
    lastMessage: 'Sent you a message.',
    lastMessageDate: '15 hours ago',
  },
  {
    name: 'Sita Rajak',
    lastMessage: 'Hi',
    lastMessageDate: '17 hours ago',
  },
  {
    name: 'Chanda Shrestha',
    lastMessage: 'Sent you a message.',
    lastMessageDate: '17 hours ago',
  },
  {
    name: 'Hari Prasad',
    lastMessage: 'How are you?',
    lastMessageDate: '17 hours ago',
  },
  {
    name: 'Admin Shrestha',
    lastMessage: 'I am fine',
    lastMessageDate: '17 hours ago',
  },
];
